module.exports = __webpack_public_path__ + "media/assets/ChevronRight-3175ada01f6c2f60f1a7b7a27bbf674d.svg";